import * as React from "react"
import TextField from "@mui/material/TextField"
import { AutocompleteChipsProps } from "./types"

export const getRenderInput = (props: AutocompleteChipsProps) => {
  return (params) => (
    <TextField
      {...params}
      variant="filled"
      label={props.title}
      // placeholder={props.title}
    />
  )
}
